// frontend/src/components/LandingPage/FeaturedCompanies.js
// (Create a new folder 'LandingPage' in 'components' if it doesn't exist)
import React from 'react';
import './FeaturedCompanies.css'; // We'll create this CSS file for the animation

const FeaturedCompanies = () => {
  const companies = [
    'Google', 'Meta', 'Microsoft', 'OpenAI', 'Amazon Web Services', 
    'Apple', 'Nvidia', 'Intel', 'DeepMind', 'Hugging Face', 
    'Salesforce AI', 'Adobe Sensei'
    // Add more or repeat for a smoother, longer scroll
  ];

  // Duplicate the list to create a seamless loop for the marquee effect
  const duplicatedCompanies = [...companies, ...companies];

  return (
    <div className="py-12 md:py-16 bg-gradient-to-b from-blue-50 to-white"> {/* Matches Hero section gradient */}
      <div className="container mx-auto px-6 text-center">
        <h2 className="text-sm font-semibold text-blue-600 uppercase tracking-wider mb-3">
          Unlock Insights From The Leaders In AI
        </h2>
        <p className="text-2xl md:text-3xl font-bold text-gray-800 mb-10">
          Learn from the research and developments at companies like:
        </p>
        
        <div className="featured-companies-marquee-container overflow-hidden relative w-full">
          <div className="featured-companies-marquee flex">
            {duplicatedCompanies.map((company, index) => (
              <div 
                key={index} 
                className="company-name whitespace-nowrap text-xl md:text-2xl font-medium text-gray-600 mx-6 sm:mx-8 md:mx-10 py-2"
              >
                {company}
              </div>
            ))}
          </div>
          {/* Optional: Add a gradient overlay for a fade-out effect at the edges if desired */}
          {/* <div className="absolute inset-y-0 left-0 w-16 bg-gradient-to-r from-blue-50 to-transparent"></div> */}
          {/* <div className="absolute inset-y-0 right-0 w-16 bg-gradient-to-l from-blue-50 to-transparent"></div> */}
        </div>
      </div>
    </div>
  );
};

export default FeaturedCompanies;

